import React from 'react'
import {
  Smile,
  PieChart,
  Users,
  Youtube,
  BookOpen,
  HelpCircle,
  LogOut,
  LucideIcon,
} from 'lucide-react'
import { UserMenuProps } from '../../../types/header'
import { useNavigation } from '../../../hooks/header/useNavigation'
import { useAuthHeader } from '../../../hooks/header/useAuthHeader'
import { PC_USER_MENU } from '../../../constants/navigation'
import { UserType } from '../../../utils/common'

const HeaderUserMenu: React.FC<UserMenuProps> = ({
  isOpen,
  onClose,
  userName,
  userType,
}) => {
  const { moveToPageByPath } = useNavigation()
  const { hasYoutubeAuthPermission, handleLogout } = useAuthHeader()

  // 아이콘 매핑
  const getIcon = (iconName: string): LucideIcon | null => {
    const iconMap: { [key: string]: LucideIcon } = {
      Smile: Smile,
      PieChart: PieChart,
      Users: Users,
      Youtube: Youtube,
      BookOpen: BookOpen,
      HelpCircle: HelpCircle,
      LogOut: LogOut,
    }
    return iconMap[iconName] || null
  }

  const handleMenuClick = (path: string) => {
    onClose()

    if (path === 'logout') {
      handleLogout()
      return
    }

    if (path === 'blog') {
      window.open(
        'https://blog.fastseller.shop/',
        '_blank',
        'noopener,noreferrer'
      )
      return
    }

    moveToPageByPath(path)
  }

  if (!isOpen) return null

  return (
    <div
      className="flex flex-col bg-[#FFFFFF] w-[240px] h-auto absolute right-[30px] border border-[#D9DEE8] rounded-[10px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)] top-20 z-50 text-[14px]  py-4 "
      onMouseLeave={onClose}
    >
      {PC_USER_MENU.map((el, index) => {
        // 구분선
        if (el.name === 'line') {
          return (
            <div className="w-full px-3">
              <div
                key={index}
                className="w-full h-0 border-t border-dashed border-[#D9DEE8]"
              />
            </div>
          )
        }

        // 자동 업로드 설정 권한 확인
        if (el.path === 'youtube-auth' && !hasYoutubeAuthPermission()) {
          return null
        }

        // 메뉴 아이템 (아이콘 + 텍스트)
        const IconComponent = el.icon ? getIcon(el.icon) : null

        return (
          <button
            key={index}
            onClick={() => handleMenuClick(el.path)}
            className="flex items-center gap-2 text-left hover:bg-[#F6F8FB] w-full p-0 transition-colors  px-6 h-[46px] "
          >
            {/* 아이콘 */}
            {IconComponent && (
              <div className="w-4 h-4 flex items-center justify-center">
                <IconComponent
                  size={16}
                  className="stroke-[#2E343D] stroke-[1.4px]"
                />
              </div>
            )}

            {/* 텍스트 */}
            <span className="text-[14px] font-medium text-[#2E343D]">
              {el.name}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default HeaderUserMenu
